export default __webpack_public_path__ + "static/media/quiz_bg.c0be8242.png";